export default "__VITE_ASSET__K4SyuzN4__"